import { NavLink, useLocation } from "react-router-dom";
import { baseUrl } from "../../../utils/apiData";
import "./WorkInfo.scss";
import { motion } from "framer-motion";
import { Fragment, useContext } from "react";
import { mainContext } from "../../../utils/WebContext";

const WorkInfo = ({ data }) => {
  const { involvedService } = useContext(mainContext);
  const path = useLocation();
  return (
    <section className="data_detail p_t p_B">
      <div className="content_wrap p_b">
        {path?.pathname?.startsWith("/get-involved") && (
          <div className="tab_wrap">
            {involvedService?.map((data) => {
              return (
                <Fragment key={data?._id}>
                  <NavLink to={`/get-involved/${data?.slug}`}>{data?.name}</NavLink>
                </Fragment>
              );
            })}
          </div>
        )}
        <div className="img_wrap">
          <img src={`${baseUrl}/${data?.image}`} alt="Work" />
        </div>

        <div className="info_content">
          <motion.div
            initial={{ translateY: 24, opacity: 0 }}
            whileInView={{ translateY: 0, opacity: 1 }}
            transition={{ duration: 0.6, ease: "easeInOut" }}
            viewport={{ once: true }}
            className="des"
            dangerouslySetInnerHTML={{
              __html: data?.content,
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default WorkInfo;
